import { createSelector } from 'reselect'

const getEmbed = (embeds, embedId) => embeds.find(embed => embed.id === embedId);
export const makeGetEmbed = () => createSelector(getEmbed, embed => embed);

const getProjectEmbeds = (embeds, projectId) => embeds.filter(embed => !embed.removed && embed.project_id === projectId)
    .sort((e1, e2) => {
        return new Date(e1.created_at) - new Date(e2.created_at);
    });
export const makeGetProjectEmbeds = () => createSelector(getProjectEmbeds, embeds => embeds);
